import { Component, HostBinding, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfigurationService } from '@box-core/services';
import { LandingEarnDialogComponent } from '../landing-earn-dialog/landing-earn-dialog.component';
import { generateImageSrc, generateImageSrcSet } from '@box/utils';

@Component({
  selector: 'landing-earn',
  templateUrl: './landing-earn.component.html',
  styleUrls: ['./landing-earn.component.scss']
})
export class LandingEarnComponent implements OnInit {
  public webpSrcSet: string;
  public pngSrcSet: string;
  public imagePng3: string;

  constructor(private dialog: MatDialog, private configurationService: ConfigurationService) {}

  @HostBinding('class') public hostClass = 'landing-earn';

  ngOnInit(): void {
    this.setLandingEarnImagesSrc();
  }

  public onShowVideo(): void {
    this.openEarnDialog();
  }

  private openEarnDialog(): void {
    const dialogConfig: MatDialogConfig = {
      autoFocus: false,
      restoreFocus: false,
      panelClass: 'box-dialog--large'
    };
    this.dialog.open(LandingEarnDialogComponent, dialogConfig);
  }

  private setLandingEarnImagesSrc(): void {
    const landingEarnData = this.configurationService.getConfiguration()?.webLandingEarn;
    this.imagePng3 = generateImageSrc(landingEarnData.png, '@3x');
    this.webpSrcSet = generateImageSrcSet(landingEarnData.webp);
    this.pngSrcSet = generateImageSrcSet(landingEarnData.png);
  }
}
